<template>
    <div class="home">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                        <ValidationObserver v-slot="{ errors }" tag="div">
                            <input-form
                            ref="form"
                            :errors="errors"
                            name="ConfirmationPage"
                            @submit.prevent="submit"
                            >
                                <div class="content">
                                    <h1>Confirmation Page</h1>
                                    <br>
                                    <div class="object-border">
                                        <h2>Unit Information</h2>
                                        <div class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>Certification:</b> {{ FullApplication.Certification }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Address:</b> {{ FullApplication.ProjectAddress.Street1 }} {{ FullApplication.ProjectAddress.Street2 }} {{ FullApplication.ProjectAddress.City }}, {{ FullApplication.ProjectAddress.State }} {{ FullApplication.ProjectAddress.Zip }}</p>
                                            </div>
                                        </div>
                                        <div class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>Number of Bedrooms:</b> {{ FullApplication.NumOfBedrooms }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Unit Occupation Date:</b> {{ new Date(FullApplication.UnitOccupationDate).toLocaleDateString("en-US", {timeZone: "UTC"}) }}</p>
                                            </div>
                                        </div>
                                        <div class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>AMI (%):</b> {{ FullApplication.AffordabilityRestrictions }}%</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Section 8 Voucher:</b> {{ FullApplication.Section8Voucher }}</p>
                                            </div>
                                        </div>
                                        <table v-if="FullApplication.UtilityAllowanceItems.length > 0" class="utility-allowance" style="border-width: 2px; border-style: solid; width: 70%; margin-left: 13%;">
                                            <tr style="background-color: #2176d2; color: white;">
                                                <td><b>Utility or Service</b></td>
                                                <td><b>per month cost</b></td>
                                            </tr>
                                            <tr
                                            v-for="item in FullApplication.UtilityAllowanceItems"
                                            :key="item.name"
                                            :class="`utility-item-${item.name}`"
                                            >
                                                <td v-if="item.name == 'Total'" style="background-color: #fff7d0; border-right-width: 2px;"><b>{{ item.name }}</b></td>
                                                <td v-else style="border-right-width: 2px;">{{ item.name }}</td>
                                                <td v-if="item.name == 'Total'" style="background-color: #fff7d0;"><b>{{ item.cost.toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</b></td>
                                                <td v-else>{{ item.cost.toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</td>
                                            </tr>
                                    </table>
                                    <div v-if="FullApplication.UtilityAllowanceItems.length > 0" style="border-width: 2px; border-style: solid; width: 70%; margin-left: 13%; padding: 0.5%;">
                                        <div class="columns">
                                            <div class="column">
                                                <p><b>Gross Rent Limit:</b> {{ FullApplication.GrossRentLimit.toLocaleString("en-US", {style: "currency", currency: "USD"}) }} per month</p>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <p><b>Utility Allowance Schedule:</b> {{ FullApplication.UtilityAllowanceTotal.toLocaleString("en-US", {style: "currency", currency: "USD"}) }} per month</p>
                                            </div>
                                        </div>

                                        <div class="columns">
                                            <div class="column">
                                                <p><b>Maximum Monthly Rent Charged to Tenant:</b> {{ (FullApplication.GrossRentLimit - FullApplication.UtilityAllowanceTotal) > 0 ? (FullApplication.GrossRentLimit - FullApplication.UtilityAllowanceTotal).toLocaleString("en-US", {style: "currency", currency: "USD"}) : 0 }} per month</p>
                                            </div>
                                        </div>
                                    </div>
                                    <a href="/LeaseUpForm" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                                    </div>
                                    <br>
                                    <div
                                    v-for="tenant in FullApplication.TenantList"
                                    :key="tenant.id"
                                    :class="`tenant-${tenant.id}`"
                                    >
                                    <div class="object-border">
                                        <h2>{{ tenant.FirstName }} {{ tenant.LastName }}</h2>

                                        <div class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>Race:</b> {{ tenant.Race }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Ethnicity:</b> {{ tenant.Ethnicity }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Date Of Birth:</b> {{ new Date(tenant.DateOfBirth).toLocaleDateString("en-US", {timeZone: "UTC"}) }}</p>
                                            </div>
                                            <div class="column" v-if="tenant.HasTaxes == 'Yes'">
                                                <p><b>Gross Tax Amount:</b> {{ Number(tenant.GrossTaxes).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                                            </div>
                                        </div>
                                        <!-- <div v-if="tenant.Incomes.length > 0" class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>Pay Stub:</b> {{ tenant.PayStub[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Pay Stub 2:</b> {{ tenant.PayStub2[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Pay Stub 3:</b> {{ tenant.PayStub3[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Pay Stub 4:</b> {{ tenant.PayStub4[0].name }}</p>
                                            </div>
                                        </div> -->
                                        <div v-if="tenant.Incomes.length > 0" class="columns" style="margin-left: 2%;">
                                            <!-- <div class="column">
                                                <p><b>Proof Of Income:</b> {{ tenant.ProofOfIncome[0].name }}</p>
                                            </div> -->
                                            <div class="column" v-if="tenant.HasTaxes == 'Yes'">
                                                <p><b>Tax Return:</b> {{ tenant.TaxReturn[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Credit Report:</b> {{  tenant.CreditReport[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>State Issues ID:</b> {{ tenant.ID[0].name }}</p>
                                            </div>
                                        </div>
                                        <div v-if="tenant.Incomes.length < 1" class="columns" style="margin-left: 2%;">
                                            <div class="column">
                                                <p><b>Credit Report:</b> {{ tenant.CreditReport[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>State Issued ID:</b> {{ tenant.ID[0].name }}</p>
                                            </div>
                                            <div class="column">
                                                <p><b>Certificate of Zero Income:</b> {{ tenant.ZeroIncomeCert[0].name }}</p>
                                            </div>
                                        </div>

                                        <table v-if="tenant.Incomes.length > 0" style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%;">
                                                <tr style="background-color: #2176d2; color: white;">
                                                    <td><b>Income Type</b></td>
                                                    <td><b>Annual Amount</b></td>
                                                    <td><b>Pay Stub</b></td>
                                                    <td><b>Pay Stub 2</b></td>
                                                    <td><b>Pay Stub 3</b></td> 
                                                    <td><b>Pay Stub 4</b></td>
                                                    <td><b>Proof Of Income</b></td>
                                                </tr>
                                                <tr
                                                v-for="income in tenant.Incomes"
                                                :key="income.id"
                                                :class="`utility-item-${income.id}`"
                                                >
                                                    <td style="border-right-width: 2px;">{{ income.IncomeType }}</td>
                                                    <td style="border-right-width: 2px;">{{ Number(income.Income).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</td>
                                                    <td style="border-right-width: 2px;" v-if="income.PayStub.length > 0"><i class="fa fa-solid fa-check"></i></td>
                                                    <td style="border-right-width: 2px;" v-else>N/A</td>
                                                    <td style="border-right-width: 2px;" v-if="income.PayStub2.length > 0"><i class="fa fa-solid fa-check"></i></td>
                                                    <td style="border-right-width: 2px;" v-else>N/A</td>
                                                    <td style="border-right-width: 2px;" v-if="income.PayStub3.length > 0"><i class="fa fa-solid fa-check"></i></td>
                                                    <td style="border-right-width: 2px;" v-else>N/A</td>
                                                    <td style="border-right-width: 2px;" v-if="income.PayStub4.length > 0"><i class="fa fa-solid fa-check"></i></td>
                                                    <td style="border-right-width: 2px;" v-else>N/A</td>
                                                    <td v-if="income.ProofOfIncome.length > 0"><i class="fa fa-solid fa-check"></i></td>
                                                    <td v-else>N/A</td>
                                                </tr>
                                        </table>
                                        <!-- <table v-if="tenant.GrossTaxes.length > 0" style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%;">
                                                <tr style="background-color: #2176d2; color: white;">
                                                    <td>Gross Taxes</td>
                                                    <td>Annual Tax Amount</td>
                                                </tr>
                                                <tr
                                                v-for="taxes in tenant.GrossTaxes"
                                                :key="taxes.id"
                                                :class="`utility-item-${taxes.id}`"
                                                >
                                                    <td style="border-right-width: 2px;">Gross Taxes - {{ taxes.id }}</td>
                                                    <td>{{ Number(taxes.GrossAmount).toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</td>
                                                </tr>
                                        </table> -->
                                        <a :href="`/TenantIncome/${tenant.id}`" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                                        </div>
                                        <br>
                                    </div>
                                    <div class="object-border" v-if="FullApplication.ChildList.length > 0">
                                    <h2>Children</h2>
                                        <table style="border-width: 2px; border-style: solid;">
                                                <tr style="background-color:#2176d2; color: white;">
                                                    <td><b>Name</b></td>
                                                    <td><b>Date Of Birth</b></td>
                                                </tr>
                                                <tr
                                                v-for="child in FullApplication.ChildList"
                                                :key="child.id"
                                                :class="`child-${child.id}`"
                                                >
                                                    <td style="border-right-width: 2px;">{{ child.FirstName }} {{ child.LastName }}</td>
                                                    <td>{{ new Date(child.DateOfBirth).toLocaleDateString("en-US", {timeZone: "UTC"}) }}</td>
                                                </tr>
                                        </table>
                                        <a href="/ChildInfoTest" class="button"><i class="fa fa-solid fa-edit" style="font-size: x-large;"></i></a>
                                    </div>
                                    <br>
                                    <div class="columns">
                                        <div class="column">
                                            <p><b>Total household size including all individuals who reside in the unit:</b> {{ FullApplication.TenantList.length + FullApplication.ChildList.length }}</p>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column">
                                            <p><b>Total Household Income:</b> {{ totalHouseholdIncome().toLocaleString("en-US", {style: "currency", currency: "USD"}) }}</p>
                                        </div>
                                    </div>
                                </div>
                                <template #submit> 
                                    <div class="action columns" style="text-align: end;">
                                        <div class="column">
                                            <button
                                                type="button"
                                                class="button is-primary"
                                                @click="submit"
                                            >
                                            Submit
                                            </button>
                                        </div>
                                    </div>
                                    <div class="column">
                                            <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                                            Submitting...
                                            </div>
                                            <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                                            OK
                                            </div>
                                            <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                                            Error
                                            </div>
                                        </div>
                                </template>
                            </input-form>
                        </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import options from "@/utilities/options";
import axios from "axios";
import { dataObjectToXml, resizeImage, getBase64 } from "@/utilities/functions.js";
import buildCreateMIHTenantCertificationObject from "@/utilities/create-mih-tenant-certification.js";
import buildCreateMIHTenantObject from "@/utilities/create-tenant-certification.js";
import buildCreateMIHTenantIncomeObject from "@/utilities/create-tenant-income.js";

export default {
  name: 'ConfirmationPage',
  mixins: [options],
  data(){
    return{
        FullApplication: null,
    }
  },
  async mounted(){
    window.scrollTo(0, 0);
    this.FullApplication = await this.$vlf.getItem('fullApplication');
    this.totalHouseholdIncome();
  },
  methods:{
    totalHouseholdIncome(){
        var totalIncomeList = this.FullApplication.TenantList.map(e => e.Incomes).filter(e => e.length > 0);
        var totalTaxesList = this.FullApplication.TenantList.map(e => Number(e.GrossTaxes)).reduce((a,b) => a + b);
        var totalIncome = 0;
        var totalGrossTaxes = totalTaxesList;

        for(var i = 0; i < totalIncomeList.length; i++){
            totalIncome += totalIncomeList[i].map(e => Number(e.Income)).reduce((a,b) => a + b);
        }


        return (totalGrossTaxes >= totalIncome) ? totalGrossTaxes : totalIncome;
    },
    async getFile(uploadData){
      if (uploadData.length) {
        var vData = this;
        let FileIdx = uploadData.length - 1;
        var fileObj = uploadData[FileIdx];
        fileObj.uploading = true;
        fileObj.error = false;
        fileObj.errorMessage = "";
        let file = fileObj.file;
        // Resize images
        if (fileObj.type.match(/image.*/)) {
          file = await resizeImage({ file: file, maxSize: 1920 });
        }
        // Only allow PDF, PNG, and JPEG
        if(file.type != "application/pdf" && file.type != "image/png" && file.type != "image/jpeg"){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "Wrong file type";
          throw "Wrong File Type";
        }
        // Set a file size limit
        if (file.size >= 1024 * 1024 * 4.5) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "File is too large, please reduce your file's size and try again.";
          throw "File is too large";
        } else {
          return await getBase64(file);
        }
      }
    },
    async submitMIHTenantIncome(relatedTenant, incomes){
            var vData = this;
            for(var i = 0; i < incomes.length; i++){
                let currIncome = incomes[i];
                let payStubFile = (currIncome.PayStub.length > 0) ? await this.getFile(currIncome.PayStub) : [];
                let payStubName = (currIncome.PayStub.length > 0) ? currIncome.PayStub[0].name : '';
                let payStub2File = (currIncome.PayStub2.length > 0) ? await this.getFile(currIncome.PayStub2) : [];
                let payStub2Name = (currIncome.PayStub2.length > 0) ? currIncome.PayStub2[0].name : '';
                let payStub3File = (currIncome.PayStub3.length > 0) ? await this.getFile(currIncome.PayStub3) : [];
                let payStub3Name = (currIncome.PayStub3.length > 0) ? currIncome.PayStub3[0].name : '';
                let payStub4File = (currIncome.PayStub4.length > 0) ? await this.getFile(currIncome.PayStub4) : [];
                let payStub4Name = (currIncome.PayStub4.length > 0) ? currIncome.PayStub4[0].name : '';
                let proofOfIncomeFile = (currIncome.ProofOfIncome.length > 0) ? await this.getFile(currIncome.ProofOfIncome) : [];
                let proofOfIncomeName = (currIncome.ProofOfIncome.length > 0) ? currIncome.ProofOfIncome[0].name : '';

                const dataObject = buildCreateMIHTenantIncomeObject(currIncome, relatedTenant,
                payStubFile, payStubName, 
                payStub2File, payStub2Name, 
                payStub3File, payStub3Name, 
                payStub4File, payStub4Name,
                proofOfIncomeFile, proofOfIncomeName);

                const xmlDataObject = dataObjectToXml(dataObject);
                const requestObject = {
                  table: "bvbjjva9i",
                  action: "API_AddRecord",
                  data: xmlDataObject
                };
            await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              ).then(response => {
                console.log(response);
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch(() => {
                vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              })
          }
        
    },
    async submitMIHChildren(relatedProject){
            var vData = this;
        
            for(var i = 0; i < vData.FullApplication.ChildList.length; i++){
                let currChild = vData.FullApplication.ChildList[i];
                let taxReturnFile = [];
                let taxReturnName = '';
                let creditReportFile = [];
                let creditReportName = '';
                let idFile = [];
                let idName = '';
                let zeroIncomeCertFile = [];
                let zeroIncomeCertName = '';

                const dataObject = buildCreateMIHTenantObject(currChild, relatedProject,
                taxReturnFile, taxReturnName, creditReportFile, creditReportName, 
                idFile, idName, zeroIncomeCertFile, zeroIncomeCertName);

                const xmlDataObject = dataObjectToXml(dataObject);
                const requestObject = {
                table: "bvbjjhy9p",
                action: "API_AddRecord",
                data: xmlDataObject
                };

            await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(response => {
                console.log(response);
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch((e) => {
                console.log(e);
                vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              })

            }
         
    },
    async submitMIHTenant(relatedProject){
        var vData = this;
        
            for(var i = 0; i < vData.FullApplication.TenantList.length; i++){
                let currTenant = vData.FullApplication.TenantList[i];
                let taxReturnFile = (currTenant.TaxReturn.length > 0) ? await this.getFile(currTenant.TaxReturn) : [];
                let taxReturnName = (currTenant.TaxReturn.length > 0) ? currTenant.TaxReturn[0].name : '';
                let creditReportFile = (currTenant.CreditReport.length > 0) ? await this.getFile(currTenant.CreditReport) : [];
                let creditReportName = (currTenant.CreditReport.length > 0) ? currTenant.CreditReport[0].name : '';
                let idFile = (currTenant.ID.length > 0) ? await this.getFile(currTenant.ID) : [];
                let idName = (currTenant.ID.length > 0) ? currTenant.ID[0].name : '';
                let zeroIncomeCertFile = (currTenant.ZeroIncomeCert.length > 0) ? await this.getFile(currTenant.ZeroIncomeCert) : [];
                let zeroIncomeCertName = (currTenant.ZeroIncomeCert.length > 0) ? currTenant.ZeroIncomeCert[0].name : '';

                const dataObject = buildCreateMIHTenantObject(currTenant, relatedProject,
                taxReturnFile, taxReturnName, creditReportFile, creditReportName, 
                idFile, idName, zeroIncomeCertFile, zeroIncomeCertName);

                const xmlDataObject = dataObjectToXml(dataObject);
                const requestObject = {
                table: "bvbjjhy9p",
                action: "API_AddRecord",
                data: xmlDataObject
                };

            await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(response => {
                console.log(response);
                this.submitMIHTenantIncome(response.data.qdbapi.rid._text, currTenant.Incomes);
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch((e) => {
                console.log(e);
                vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              })

            }
         
    },
    async submitMIHTenantCertification(){
          var vData = this;
          
            let leaseFile = (vData.FullApplication.LeaseForm.length > 0) ? await this.getFile(vData.FullApplication.LeaseForm) : [];
            let leaseName = (vData.FullApplication.LeaseForm.length > 0) ? vData.FullApplication.LeaseForm[0].name : '';
            let acknowledgementCertFile = (vData.FullApplication.AcknowledgementCert.length > 0) ? await this.getFile(vData.FullApplication.AcknowledgementCert) : [];
            let acknowledgementCertName = (vData.FullApplication.AcknowledgementCert.length > 0) ? vData.FullApplication.AcknowledgementCert[0].name : '';
            let section8VoucherFile = (vData.FullApplication.ProofOfSection8.length > 0) ? await this.getFile(vData.FullApplication.ProofOfSection8) : [];
            let section8VoucherName = (vData.FullApplication.ProofOfSection8.length > 0) ? vData.FullApplication.ProofOfSection8[0].name : '';
            
            const dataObject = buildCreateMIHTenantCertificationObject(vData, 
            leaseFile, leaseName, 
            acknowledgementCertFile, acknowledgementCertName, 
            section8VoucherFile, section8VoucherName);

            const xmlDataObject = dataObjectToXml(dataObject);
            const requestObject = {
              table: "buwpmeivf",
              action: "API_AddRecord",
              data: xmlDataObject
            };
        await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(async response => {
                console.log(response);
                await this.submitMIHTenant(response.data.qdbapi.rid._text);
                await this.submitMIHChildren(response.data.qdbapi.rid._text);
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                // this.awsFiles[i].uploading = false;
                // this.awsFiles[i].success = true;
              }).catch(() => {
                vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              })
          
    },
    async submit(){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        await this.submitMIHTenantCertification();
        this.$vlf.removeItem('fullApplication');
        this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
        this.$router.push({
            name: "SuccessPage",
        });
    }
  }
}
</script>

<style>
.object-border{
    border-width: 5px;
    border-style: solid;
    padding: 1%;
    border-radius: 10px;
    border-color: #0f4d90;
}
</style>